import { wait } from '../wait.js';
export function withRetry(fn) {
  let {
    delay: delay_ = 100,
    retryCount = 2,
    shouldRetry = () => true
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise((resolve, reject) => {
    const attemptRetry = async function () {
      let {
        count = 0
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const retry = async _ref => {
        let {
          error
        } = _ref;
        const delay = typeof delay_ === 'function' ? delay_({
          count,
          error
        }) : delay_;
        if (delay) await wait(delay);
        attemptRetry({
          count: count + 1
        });
      };
      try {
        const data = await fn();
        resolve(data);
      } catch (err) {
        if (count < retryCount && (await shouldRetry({
          count,
          error: err
        }))) return retry({
          error: err
        });
        reject(err);
      }
    };
    attemptRetry();
  });
}
//# sourceMappingURL=withRetry.js.map